import React, { useState } from "react";
import {
  Stack,
  Box,
  Text,
  SimpleGrid,
  Divider,
} from "@chakra-ui/react";
import ReusableDrawer from "components/Drawers/ReusableDrawer";
import GradientButton from "components/Buttons/GradientButton";
import ReusableInput from "components/Inputs/ReusableInput";

const AddLoyaltyConfigDrawer = ({ isOpen, onClose, onAdd }) => {
  const [formData, setFormData] = useState({
    points_per_pula: 1,
    referral_percentage: 0.1,
    min_points: 5,
    max_points: 50,
    driver_referral_base: 30,
    bronze_threshold: 0,
    silver_threshold: 500,
    gold_threshold: 1500,
    platinum_threshold: 4000,
    bronze_multiplier: 1,
    silver_multiplier: 1.1,
    gold_multiplier: 1.25,
    platinum_multiplier: 1.5,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: Number(value),
    }));
  };

  const handleSubmit = () => {
    onAdd(formData);
    onClose();
  };

  const formatLabel = (key) =>
    key
      .replace(/_/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase());

  const coreFields = [
    "points_per_pula",
    "referral_percentage",
    "min_points",
    "max_points",
    "driver_referral_base",
  ];

  const tierFields = [
    "bronze_threshold",
    "silver_threshold",
    "gold_threshold",
    "platinum_threshold",
  ];

  const multiplierFields = [
    "bronze_multiplier",
    "silver_multiplier",
    "gold_multiplier",
    "platinum_multiplier",
  ];

  const renderGroup = (title, fields) => (
    <Box>
      <Text fontSize="md" fontWeight="bold" mb={3}>
        {title}
      </Text>

      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
        {fields.map((key) => (
          <ReusableInput
            key={key}
            label={formatLabel(key)}
            name={key}
            value={formData[key]}
            onChange={handleChange}
            type="number"
          />
        ))}
      </SimpleGrid>
    </Box>
  );

  return (
    <ReusableDrawer
      isOpen={isOpen}
      onClose={onClose}
      headerContent={<h2>Create Loyalty Config</h2>}
      bodyContent={
        <Stack spacing={6}>
          <Box>
            <Text fontSize="lg" fontWeight="bold">
              Configuration Settings
            </Text>
            <Divider mt={2} />
          </Box>
          {renderGroup("Core Settings", coreFields)}
          {renderGroup("Tier Thresholds", tierFields)}
          {renderGroup("Tier Multipliers", multiplierFields)}
        </Stack>
      }
      footerContent={
        <Stack direction="row" justify="flex-end" spacing={3}>
          <GradientButton
            onClick={onClose}
            width="120px"
            height="36px"
            fontSize="13px"
          >
            Cancel
          </GradientButton>

          <GradientButton
            onClick={handleSubmit}
            width="140px"
            height="36px"
            fontSize="13px"
          >
            Save
          </GradientButton>
        </Stack>
      }
    />
  );
};

export default AddLoyaltyConfigDrawer;